export enum CheckoutClientType {
  PRIVATE = 'PRIVATE',
  COMPANY = 'COMPANY'
}
